import React from "react"
import { DatoContentBaseProps } from "../../types"

import StripVideoBanner, {
  StripVideoBannerItem,
} from "@components/StripVideoBanner"

interface DatoCmsComponentStripVideoBannerProps extends DatoContentBaseProps {}

const hexToRgb = (hex?: string) => {
  if (!hex) return undefined
  const value = hex.replace("#", "")
  if (value.length !== 6) return undefined
  const red = parseInt(value.slice(0, 2), 16)
  const green = parseInt(value.slice(2, 4), 16)
  const blue = parseInt(value.slice(4, 6), 16)
  return `${red}, ${green}, ${blue}`
}

const formatItem = (item: any): StripVideoBannerItem => ({
  title: item?.videoTitle || "",
  logo: item?.logo?.url || "",
  video: item?.videoLink?.url || "",
  streamingUrl: item?.videoLink?.video?.streamingUrl,
  fallbackVideoUrl:
    item?.videoLink?.video?.mp4Low || item?.videoLink?.url || "",
  posterSrc:
    item?.videoThumbnail?.responsiveImage?.src || item?.videoThumbnail?.url,
  overlayRgb: hexToRgb(item?.overlayRgb?.hex) || "220, 26, 32",
  desc1: item?.descriptionLine1,
  desc2: item?.descriptionLine2,
  pill: item?.pillText,
  redirect: item?.redirect,
})

const DatoCmsComponentStripVideoBanner: React.FC<
  DatoCmsComponentStripVideoBannerProps
> = ({
  optionValues,
  promoBanner,
  promoBannerMobile,
  height = "calc(100vh - 115px)",
  mobileHeight = "calc(100vh - 108px)",
}) => {
  const items = Array.isArray(optionValues) ? optionValues : []
  const promoBannerImages = Array.isArray(promoBanner)
    ? promoBanner
        .filter((image) => Boolean(image?.url))
        .map((image) => ({
          src: image.url,
          alt: image.alt || "Promo banner",
        }))
    : promoBanner?.url
    ? [
        {
          src: promoBanner.url,
          alt: promoBanner.alt || "Promo banner",
        },
      ]
    : []

  const promoBannerMobileImages = Array.isArray(promoBannerMobile)
    ? promoBannerMobile
        .filter((image) => Boolean(image?.url))
        .map((image) => ({
          src: image.url,
          alt: image.alt || "Promo banner",
        }))
    : promoBannerMobile?.url
    ? [
        {
          src: promoBannerMobile.url,
          alt: promoBannerMobile.alt || "Promo banner",
        },
      ]
    : []

  if (items.length === 0) return null

  return (
    <StripVideoBanner
      items={items.map(formatItem)}
      height={height}
      mobileHeight={mobileHeight}
      promoBannerImages={promoBannerImages}
      promoBannerMobileImages={promoBannerMobileImages}
      promoBannerImage={promoBannerImages[0]}
      promoBannerMobileImage={promoBannerMobileImages[0]}
    />
  )
}

export default DatoCmsComponentStripVideoBanner
